/* ConfigAuditParamsComponent.js */

"use strict";
const EventEmitter = require("events");
const Renderer = require("./ConfigAuditParamsRenderer");

class ConfigAuditParamsComponent extends EventEmitter {
    constructor(actionComponent, showDeviceSelection, getPolicyLabels, resolver, logger) {
        super();
        this._logger = logger;
        this._actionComponent = actionComponent;
        this._resolver = resolver;

        this.data = {
            name: null,
            selection: showDeviceSelection ? "selected" : null,
            captureName: undefined,
            policy: null,
            schedule: null
        };

        this._registerListeners();

        this._renderer = new Renderer(this, this.data, logger);
        this.renderProm = this._renderer.render();

        getPolicyLabels().then(this._triggerGotPolicyLabels.bind(this));
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/
    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        if (this.shutdownProm === null) {
            return Promise.resolve();
        }
        this.shutdownProm =
            this.shutdownProm ||
            this._renderer
                .shutdown()
                .then(() => {
                    this._unregisterListeners();
                    this._renderer = null;
                    this.shutdownProm = null;
                    this._logger = null;
                })
                .catch((error) => {
                    this._logger.warn({ error }, `${this.constructor.name}  shutdown Error`);
                });
        return this.shutdownProm;
    }

    configAuditStart(data) {
        this._resolver(data);
        //this._context.resolve(data);
    }

    configAuditCancel(err) {
        this._context.reject(err);
    }

    configAuditSchedule(data) {
        this._actionComponent.updateData(data);
        this._actionComponent.setScheduleView();
    }

    cancelAction(err) {
        this._context.reject(err);
    }

    /* jshint ignore:start */
    set "$teve.ui.context"(context) {
        this._context = context;
    }
    /* jshint ignore:end */

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/
    _triggerGotPolicyLabels(labels) {
        this.emit("PolicyLabels", labels);
    }
    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = ConfigAuditParamsComponent;
